// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"1f6d15db","392":"f989dd8b","439":"a243dd6c","622":"ce014cb2","854":"afd51126","976":"124e18bb"}[chunkId] + ".chunk.js";
};